import { Button, Collapse, Divider } from 'antd';
import styled from 'styled-components';

export const MobileMenuContainerStyled = styled.div`
	z-index: 9999;
	padding-top: 14px;
	width: 100vw;
	background-color: #fff;
	box-shadow: 0px 10px 12px -4px rgba(0, 0, 0, 0.06);
`;

export const ContainerStyled = styled.div`
	margin: 0 auto;
	width: calc(100vw - 32px);
	@media (min-width: ${props => props.theme.breakpoints.sm}) {
		width: 496px;
	}

	@media (min-width: ${props => props.theme.breakpoints.md}) {
		width: 688px;
	}

	@media (min-width: ${props => props.theme.breakpoints.lg}) {
		width: 916px;
	}

	@media (min-width: ${props => props.theme.breakpoints.xl}) {
		width: 1200px;
	}
`;

export const MobileMenuListStyled = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	margin: 0;
	padding: 0;
`;

export const MobileMenuListItemStyled = styled.div``;

export const CollapseStyled = styled(Collapse)`
	padding: 0;
	border: none !important;
`;

export const DividerStyled = styled(Divider)`
	margin: 0;
`;

export const ButtonStyled = styled(Button)<{ active: boolean }>`
	margin: 12px auto;
	padding: 0;
	color: ${props => (props.active ? `#1890ff` : `#262626`)};
`;

export const ButtonSubmenuStyled = styled(Button)<{ active: boolean }>`
	margin: 7px 0;
	color: ${props => (props.active ? `#1890ff` : `#262626`)};
`;

export const MobileMenuBackgroundStyled = styled.div`
	position: fixed;
	top: 52px;
	left: 0;
	z-index: -999;
	width: 100vw;
	height: 100vh;
	background-color: rgba(0, 0, 0, 0.1);
`;
